import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'form-field-string',
  templateUrl: 'form-field-string.component.html',
  styleUrls: ['form-field-string.component.scss']
})
export class FormFieldStringComponent {
  @Input() field!: any;
  @Input() formGroup!: FormGroup;

  constructor() {
  }

  ngOnInit() {

  }


}
